
const InstagramIconOutline = ({ 
  color = "#6B635D", 
  size = 24, 
  className = "",
  ...props 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z" 
        fill={color}
      />
      <path 
        d="M12 16.25C9.66 16.25 7.75 14.34 7.75 12C7.75 9.66 9.66 7.75 12 7.75C14.34 7.75 16.25 9.66 16.25 12C16.25 14.34 14.34 16.25 12 16.25ZM12 9.25C10.48 9.25 9.25 10.48 9.25 12C9.25 13.52 10.48 14.75 12 14.75C13.52 14.75 14.75 13.52 14.75 12C14.75 10.48 13.52 9.25 12 9.25Z" 
        fill={color}
      />
      <path 
        d="M17 7.4999C16.87 7.4999 16.74 7.4699 16.62 7.4199C16.5 7.3699 16.39 7.2999 16.29 7.2099C16.2 7.1099 16.12 6.9999 16.07 6.8799C16.02 6.7599 16 6.6299 16 6.4999C16 6.3699 16.02 6.2399 16.07 6.1199C16.13 5.9899 16.2 5.8899 16.29 5.7899C16.34 5.7499 16.39 5.6999 16.44 5.6699C16.5 5.6299 16.56 5.5999 16.62 5.5799C16.68 5.5499 16.74 5.5299 16.81 5.5199C17.13 5.4499 17.47 5.5599 17.71 5.7899C17.8 5.8899 17.87 5.9899 17.92 6.1199C17.97 6.2399 18 6.3699 18 6.4999C18 6.6299 17.97 6.7599 17.92 6.8799C17.87 6.9999 17.8 7.1099 17.71 7.2099C17.61 7.2999 17.5 7.3699 17.38 7.4199C17.26 7.4699 17.13 7.4999 17 7.4999Z" 
        fill={color}
      />
    </svg>
  );
};

// Facebook Icon (from second SVG)
const FacebookIconOutline = ({ 
  color = "#6B635D", 
  size = 24, 
  className = "",
  ...props 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M14.75 22.75H10.25V15.5H9.29999C8.71999 15.5 8.25 15.03 8.25 14.45V12.55C8.25 11.97 8.71999 11.5 9.29999 11.5H10.25V9C10.25 6.93 11.93 5.25 14 5.25H16.7C17.28 5.25 17.75 5.71999 17.75 6.29999V8.70001C17.75 9.28001 17.28 9.75 16.7 9.75H14.75V11.5H16.63C16.95 11.5 17.24 11.64 17.44 11.88C17.64 12.12 17.72 12.44 17.66 12.75L17.28 14.65C17.18 15.14 16.75 15.49 16.25 15.49H14.75V22.75ZM11.75 21.25H13.25V14H15.89L16.09 13H13.26V9.29999C13.26 8.71999 13.73 8.25 14.31 8.25H16.26V6.75H14C12.76 6.75 11.75 7.76 11.75 9V13H9.75V14H11.75V21.25Z" 
        fill={color}
      />
      <path 
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z" 
        fill={color}
      />
    </svg>
  );
};

// Twitter Icon (from third SVG - stroke version)
const TwitterIconOutline = ({ 
  color = "#6B635D", 
  size = 24, 
  strokeWidth = 1.5,
  className = "",
  ...props 
}) => {
  // Adjust viewBox for 24x20 SVG to fit 24x24
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M23 3.00005C22.0424 3.67548 20.9821 4.19211 19.86 4.53005C19.2577 3.83756 18.4573 3.34669 17.567 3.12393C16.6767 2.90116 15.7395 2.9572 14.8821 3.28445C14.0247 3.61171 13.2884 4.1944 12.773 4.95372C12.2575 5.71303 11.9877 6.61234 12 7.53005V8.53005C10.2426 8.57562 8.50127 8.18586 6.93101 7.39549C5.36074 6.60512 4.01032 5.43869 3 4.00005C3 4.00005 -1 13 8 17.0001C5.94053 18.398 3.48716 19.0989 1 19.0001C10 24.0001 21 19.0001 21 7.50005C20.9991 7.2215 20.9723 6.94364 20.92 6.67005C21.9406 5.66354 22.6608 4.39276 23 3.00005Z" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

// LinkedIn Icon (from fourth SVG)
const LinkedInIconOutline = ({ 
  color = "#6B635D", 
  size = 24, 
  strokeWidth = 1.71429,
  className = "",
  ...props 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 23 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M5.28683 3.02918C5.29148 3.62195 5.06263 4.19274 4.64976 4.61812C4.2369 5.04349 3.67319 5.28928 3.08055 5.30232C2.48914 5.28084 1.92859 5.03294 1.51478 4.60987C1.10096 4.18681 0.86552 3.62092 0.857117 3.02918C0.882675 2.4525 1.12667 1.90714 1.53959 1.50377C1.95251 1.1004 2.50343 0.869236 3.08055 0.857178C3.65596 0.869467 4.20492 1.10121 4.61507 1.50499C5.02522 1.90876 5.26553 2.45403 5.28683 3.02918ZM1.0954 9.34118C1.0954 8.03489 1.92683 8.23889 3.08055 8.23889C4.23426 8.23889 5.04855 8.03489 5.04855 9.34118V22.068C5.04855 23.3915 4.21712 23.1206 3.08055 23.1206C1.94397 23.1206 1.0954 23.3915 1.0954 22.068V9.34118ZM8.47712 9.34289C8.47712 8.61261 8.74797 8.34003 9.1714 8.25603C9.59483 8.17203 11.0571 8.25603 11.5645 8.25603C12.0737 8.25603 12.2777 9.08746 12.2605 9.71489C12.6965 9.13117 13.2747 8.66876 13.94 8.37169C14.6052 8.07462 15.3354 7.95277 16.0611 8.01775C16.7738 7.97423 17.4877 8.08111 18.1564 8.33145C18.8251 8.58179 19.4337 8.96998 19.9427 9.47083C20.4516 9.97167 20.8495 10.574 21.1105 11.2386C21.3715 11.9032 21.4898 12.6153 21.4577 13.3286V22.0166C21.4577 23.34 20.6434 23.0692 19.488 23.0692C18.3325 23.0692 17.52 23.34 17.52 22.0166V15.2297C17.5499 14.8805 17.5042 14.5289 17.3862 14.1989C17.2682 13.8688 17.0805 13.568 16.8359 13.3169C16.5913 13.0658 16.2956 12.8703 15.9687 12.7437C15.6419 12.617 15.2916 12.5622 14.9417 12.5829C14.5931 12.5737 14.2466 12.6387 13.9251 12.7736C13.6036 12.9085 13.3144 13.1103 13.0768 13.3654C12.8391 13.6206 12.6584 13.9233 12.5467 14.2536C12.4349 14.5839 12.3947 14.9342 12.4285 15.2812V22.068C12.4285 23.3915 11.5971 23.1206 10.4434 23.1206C9.28969 23.1206 8.4754 23.3915 8.4754 22.068L8.47712 9.34289Z" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { 
  InstagramIconOutline, 
  FacebookIconOutline, 
  TwitterIconOutline, 
  LinkedInIconOutline 
};